import { Divider, Stack, Typography } from "@mui/material";
import { useUserContext } from "../../contexts/user-context/UserContext";
import { useTranslation } from "react-i18next";

export default function UserProfileTitle() {

    const { t } = useTranslation();
    const [userState] = useUserContext();

    return (
        <Stack
            id='agg'
            sx={{
                display: 'flex',
                flexDirection: 'column',
                flex: '1 1 auto'
            }}>
            <Typography variant='h5' sx={{
                fontWeight: "bold"
            }}>
                    {userState.user?.displayText}
            </Typography>
            <Divider flexItem={true} 
                sx={{
                    borderBottomWidth: 'medium'
                }} 
            />
            <Typography variant='subtitle1' sx={{
                fontWeight: "bold"
            }}>
               {t('profile.userInfo')}
           </Typography>
        </Stack>
    );
}